import { useState } from "react";
import { db } from "../lib/firebase";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { Sidebar } from "../components/Sidebar";
import { collection, getDocs, query, where, deleteDoc, doc } from "firebase/firestore";
import { validateImportedEvent, publishImportedEvent, ImageImportError } from "../services/importedEventService";

export const AdminImportEvents = () => {
  const [json, setJson] = useState("");
  const [loading, setLoading] = useState(false);

  const handleDeleteImported = async () => {
  if (!window.confirm("Tem certeza que deseja deletar TODOS os eventos importados?")) return;

  try {
    setLoading(true);

    const q = query(
      collection(db, "events"),
      where("isImported", "==", true)
    );

    const snapshot = await getDocs(q);

    for (const docItem of snapshot.docs) {
      await deleteDoc(doc(db, "events", docItem.id));
    }

    toast.success("Eventos importados deletados 🗑️");

  } catch (e) {
    toast.error("Erro ao deletar: " + e.message);
  } finally {
    setLoading(false);
  }
};

  const handleImport = async () => {
    try {
      setLoading(true);

      let data;

        try {
        data = JSON.parse(json);
        } catch {
        toast.error("JSON inválido");
        setLoading(false);
        return;
        }

      const failures = [];
      let importedCount = 0;

      for (const event of data) {
        validateImportedEvent(event);

        // Se UMA imagem falhar (link quebrado, imagem removida, timeout),
        // pula só esse evento e segue importando o resto do lote.
        try {
          await publishImportedEvent(event);
        } catch (publishError) {
          if (!(publishError instanceof ImageImportError)) throw publishError;
          failures.push({
            title: event.title || "(sem título)",
            reason: publishError.message,
          });
          continue;
        }
        importedCount++;
      }

      if (importedCount > 0) {
        toast.success(`${importedCount} evento(s) importado(s)`);
      }

      if (failures.length > 0) {
        toast.error(
          `${failures.length} evento(s) falharam na imagem e não foram importados: ` +
          failures.map((f) => `"${f.title}" (${f.reason})`).join("; "),
          { duration: 15000 }
        );
      }

      setJson("");

    } catch (e) {
      toast.error("Erro: " + e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
  <div className="flex min-h-screen bg-background">
    <Sidebar />

    <main className="flex-1 p-4 pt-16 md:p-8 md:ml-72 space-y-6">
      <h1 className="text-3xl font-bold">Novos Eventos IA 🤖</h1>

      <textarea
        value={json}
        onChange={(e) => setJson(e.target.value)}
        placeholder="Cole aqui o JSON..."
        className="w-full h-64 p-4 border rounded-lg"
      />

      <div className="flex gap-3">
        <Button onClick={handleImport} disabled={loading}>
          {loading ? "Importando..." : "Importar Eventos"}
        </Button>

        {/* Oculto por pedido do usuário (medo de clique acidental apagar tudo
            que foi importado via IA) — função/lógica intactas, só reativar
            descomentando o bloco abaixo.
        <Button
          variant="destructive"
          onClick={handleDeleteImported}
        >
          Deletar Importados
        </Button>
        */}
      </div>
    </main>
  </div>
);
};
